import { combineReducers } from '@reduxjs/toolkit';

import selection from './selection';
import smallReducers from './smallReducers';

export default combineReducers({ selection, ...smallReducers });
